import API from '../../../manager/API';
import { dispatch } from '../../hooks';
import slice from './slice';

const { setDataProcessingStatusData } = slice.actions;

const dataProcessingStatus = (url: any) => async () => {
  try {
    const response = await API.dataProcessingStatus.dataProcessingStatus(url);
    dispatch(setDataProcessingStatusData(response.data));
    return { response, status: response.status, data: response.data };
  } catch (error: any) {
    return { status: error.response.status, data: error.response.data };
  }
};

export default {
  dataProcessingStatus
};
